<template>
  <div>
    <img src="@/assets/img/campaign/20241023_manavisfesta.jpg" /><br>
    <img src="@/assets/img/campaign/20241023_manavisfesta_02.jpg" style="margin-top: 5px;" />
  </div>
</template>


<style scoped>
</style>

<script>
</script>